import { render, staticRenderFns } from "./NotAllowedBlink.vue?vue&type=template&id=48907bb9&scoped=true&"
import script from "./NotAllowedBlink.vue?vue&type=script&lang=js&"
export * from "./NotAllowedBlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48907bb9",
  null
  
)

/* custom blocks */
import block0 from "./NotAllowedBlink.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./NotAllowedBlink.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports